
// Chakra imports
import { Flex, Text, Box, useColorModeValue } from '@chakra-ui/react';

// Custom components
import { HorizonLogo } from 'components/icons/Icons';

export function SidebarBrand(props: { mini: boolean; hovered: boolean }) {
  const { mini, hovered } = props;

  // Chakra color mode
  const logoColor = useColorModeValue('navy.700', 'white');

  return (
    <Flex
      align="center"
      justify="center"
      direction="column"
      w="100%"
    >
      {/* Logo */}
      <Flex
        w="100%"
        h="80px"
        my="32px"
        color={logoColor}
        justify="center"
        align="center"
        display={
          mini === false
            ? 'flex'
            : mini === true && hovered === true
            ? 'flex'
            : 'none'
        }
      >
        <HorizonLogo />
      </Flex>

      {/* Text */}
      <Text
        display={
          mini === false
            ? 'none'
            : mini === true && hovered === true
            ? 'none'
            : 'block'
        }
        fontSize="30px"
        fontWeight="800"
        color={logoColor}
        textAlign="center"
        w="100%"
      >
        CaliMaster
      </Text>

      <Box mb="20px" />
    </Flex>
  );
}

export default SidebarBrand;